import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { PartnerTokenTypes } from '../Types';

const machine = Machines.onPartnerToken.machine;
export const partnerToken = (
  params: PartnerTokenTypes.PartnerTokenServiceRequestType,
): Promise<PartnerTokenTypes.IPartnerTokenServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { partnerToken };
